var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJey = function SvgJey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512v341.337H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512v341.337H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M301.255 255.997L512 115.499v-30.17h-45.255L256 225.826 45.255 85.329H0v30.17l210.745 140.498L0 396.494v30.169h45.255L256 286.167l210.745 140.496H512v-30.169z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M233.739 166.953L256 172.518l22.261-5.565v-18.922l-8.904 4.453L256 139.127l-13.357 13.357-8.904-4.453z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M233.739 166.953v13.914c0 17.04 22.261 22.261 22.261 22.261s22.261-5.221 22.261-22.261v-13.914h-44.522z"
  })));
};
export { SvgJey as ReactComponent };